import { SERVER_URI, TEST_URI, SERVER_URI1 } from '../Constant/server';
import { apiGet, apiPost } from '../utils/axios';

const SIGNUP_URL = `${SERVER_URI}/login`;
const GET_CITY = `${SERVER_URI}/getStateCity`;
const GETMeasurementUnit = `${SERVER_URI}/get-unit-master`;
const GET_DURATION_DATA = SERVER_URI + '/get-duration';
const RESET_PASSWORD = SERVER_URI + '/reset-password';
const GET_PERMESSION = SERVER_URI + '/permission/get-permissiondata';
const GET_CUSTOMER = SERVER_URI + '/dashboard/get-customers';
const GET_WAIVER = SERVER_URI + '/dashboard/get-customer-waiver';
const GET_CARDS = SERVER_URI + '/dashboard/get-customer-card/';
const CUSTOMER_FEEDBACK = SERVER_URI + '/dashboard/get-customer-feedback';
const CUSTOMER_ENQUIRY = SERVER_URI + '/dashboard/get-customer-enquire';
const SEND_WAIVER_OTP = SERVER_URI1 + '/waiver/sendOtp/';
const VERIFY_WAIVER_OTP = SERVER_URI1 + '/waiver/verifyOtp';
const ADD_WAIVER = SERVER_URI1 + '/waiver/addNewWaiver';
const GET_COMPNIES = SERVER_URI + '/get-companies';
const GET_WAIVER_DETAIL = SERVER_URI + '/get-waiver-detail/'
const GET_WAIVER_DUMP = SERVER_URI + '/reports/get-waiver-dump';

export default {
  signUp: async function (payload) {
    return apiPost(SIGNUP_URL, payload);
  },
  getCity: async function (pincode) {
    const url = `${GET_CITY}/${pincode}`;
    return apiGet(url);
  },
  bindMeasurementUnit: async function (payload) {
    return apiPost(GETMeasurementUnit, payload);
  },

  getDurationData: async function (payload) {
    return apiPost(GET_DURATION_DATA, payload);
  },
  resetPassword: async function (payload) {
    return apiPost(RESET_PASSWORD, payload);
  },
  getPermession: async function (payload) {
    return apiPost(GET_PERMESSION, payload);
  },
  getCustomerData: async function (payload) {
    return apiPost(GET_CUSTOMER, payload)
  },
  getWaiverData: async function (payload) {
    return apiPost(GET_WAIVER, payload)
  },
  getCards: async function (payload) {
    return apiPost(GET_CARDS, payload)
  },
  customerFeedBack: async function (payload) {
    return apiPost(CUSTOMER_FEEDBACK, payload)
  },
  customerEnquiry: async function (payload) {
    return apiPost(CUSTOMER_ENQUIRY, payload)
  },
  SendOtp: async function (mobile) {
    return apiGet(SEND_WAIVER_OTP + mobile);
  },
  VerifyOtp: async function (payload) {
    return apiPost(VERIFY_WAIVER_OTP, payload);
  },
  AddWaiver: async function (payload) {
    return apiPost(ADD_WAIVER, payload);
  },
  getCompnies: async function (payload) {
    return apiPost(GET_COMPNIES, payload);
  },
  getWaiverDetails: async function (id) {
    return apiGet(GET_WAIVER_DETAIL + id)
  },
  getWaiverDump: async function (payload) {
    return apiPost(GET_WAIVER_DUMP, payload);
  },
};
